import React, { useCallback, useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { faStepForward } from '@fortawesome/free-solid-svg-icons';
import { PlaybackContext } from '../../contexts/PlaybackContext';
import MoviePlaylistItem from '../../models/MoviePlaylistItem';
import { PlaybackInformationContext } from '../../contexts/PlaybackInformationContext';
import { NextEpisodeButtonContainer, NextEpisodeButtonLabel, NextEpisodeIcon } from './NextEpisodeButton';

export const SkipIntroButton: React.FC = () => {
	const { t } = useTranslation();
	const { position, playbackInformationVisible, setPosition } = useContext(PlaybackInformationContext);
	const { playlistItem } = useContext(PlaybackContext);

	const introTiming = useMemo(() => {
		if (playlistItem instanceof MoviePlaylistItem && playlistItem.movie.introTiming) {
			return playlistItem.movie.introTiming;
		}

		return null;
	}, [playlistItem]);

	const visible = useMemo(() => introTiming && position > introTiming.start && position < introTiming.end, [introTiming, position]);

	const onClick = useCallback(() => {
		if (introTiming) {
			setPosition(introTiming.end);
		}
	}, [introTiming, setPosition]);

	return (
		<NextEpisodeButtonContainer visible={visible} playbackInformationVisible={playbackInformationVisible} onClick={onClick}>
			<NextEpisodeButtonLabel>{t('Player.SkipIntro')}</NextEpisodeButtonLabel>
			<NextEpisodeIcon icon={faStepForward} />
		</NextEpisodeButtonContainer>
	);
};
